import type { JSX } from 'react'

import { ThemeProvider } from './ThemeProvider'

import classes from './style.module.css'

UnknownProvider.displayName = 'UnknownProvider'
export function UnknownProvider({ text }: { text?: string }): JSX.Element {
  return (
    <ThemeProvider>
      <div className={classes.wrapper} data-testid='unknown-provider'>
        <div className={classes.unknown}></div>
        <div className={classes.unknown_title}>{text}</div>
      </div>
    </ThemeProvider>
  )
}
